module.exports = __webpack_public_path__ + "media/images/etyekilogo-etyeki-55x55-menu-71e764601a6ba62954b6807c7bffe04b.png";